import { siFacebook, siInstagram, siX } from "simple-icons"
import linkedinSvg from "@/assets/linkedInLogo.svg?raw"
import shareIconSvg from "@/assets/shareIcon.svg?raw"

export const getIcon = (socialMediaName: string): string => {
  switch (socialMediaName) {
    case "facebook":
      return siFacebook.svg
    case "x":
    case "twitter":
      return siX.svg
    case "instagram":
      return siInstagram.svg
    case "linkedin":
      return linkedinSvg
    default:
      return shareIconSvg
  }
}
